import { FunctionComponent } from "react";
import { IconProps } from "./constants";

const CheckMark: FunctionComponent<IconProps> = ({ width = 31, height = 22, color = "#305953", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-name={props.name || "checkmark"}
      data-testid="checkmark"
      {...props}
    >
      <path d="M2 11L11.9241 20L29 2" stroke={color} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2 11L11.9241 20L29 2"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckMark;
